import { useState } from "react";

const useSearch = () => {
    const [pagination, setPagination] = useState({ skip: 0, top: 10 });
    const [condition, setCondition] = useState({});
    const [params, setParams] = useState({ ...pagination, ...condition });

    const conditionHandler = source => {
        setCondition(source);
        setParams({ ...source, ...{ skip: 0, top: 10 }});
    };

    const pcaginationHandler = source => {
        pagination.skip = source;
        setPagination(pagination);
        setParams({ ...condition, ...pagination });
    };

    return [params, conditionHandler, pcaginationHandler];
};

export default useSearch;
